import { Components, Theme } from '@mui/material/styles'

export const MuiDivider: Components<Theme>['MuiDivider'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      color: theme.palette.text.secondary,
      borderColor: theme.states.text.outlinedBorder,
      textTransform: 'uppercase',
      ...theme.typography.overline,
    }),
  },
}
